import { GlButton } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { highCountTrim } from '~/lib/utils/text_utility';
export default {
    name: 'SuperSidebarCounter',
    components: {
        GlButton
    },
    props: {
        count: {
            type: [
                Number,
                String
            ],
            required: true
        },
        href: {
            type: String,
            required: false,
            default: null
        },
        icon: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        }
    },
    computed: {
        ariaLabel () {
            return `${this.count} ${this.label}`;
        },
        formattedCount () {
            if (Number.isFinite(this.count)) {
                return highCountTrim(this.count);
            }
            return this.count;
        }
    }
};
